











import Component from 'vue-class-component';
import { Mixins } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { SUBMODULES_PATHS } from '../../../store';
import { FacetsGroupMixin } from '../../mixins/facets-group.mixin';

@Component({
  computed: {
    ...mapState(SUBMODULES_PATHS.search, ['numFound', 'query'])
  }
})
export default class CloseFacetsGroup extends Mixins(FacetsGroupMixin) {
  query: string;
  numFound: number;

  get closePanelMessageParameters() {
    return {
      numFound: this.numFound,
      selectedFiltersCount: this.groupSelectedFilters.length,
      selectedFilters: this.groupSelectedFilters.map(filter => filter.title).join(', '),
      query: this.query
    };
  }

  get closePanelMessage() {
    const toggleMessages = this.$x.messages.facets.toggle;
    return toggleMessages.groups[this.groupId]?.inside?.closeHTML ?? toggleMessages.default.closeHTML;
  }
}
